import React from 'react';
import { connect } from "react-redux";

import DocumentTitle from 'react-document-title';
import localeIntl from "./intl/data.json";
import { IntlProvider } from "react-intl";
import { BrowserRouter as Router, Route } from 'react-router-dom';

import './assets/css/antd.scss';
import './assets/css/animate.css';
import './assets/css/responsive.scss';

import * as authAct from "./store/auth/_authActions";
import * as utilsAct from "./store/utils/_utilsActions";

import AuthContainer from "./screens/AuthContainer/AuthContainer";

class App extends React.Component {

  render() {
    const { _utils: { lang, pageTitle } } = this.props;
    const path = window.location.pathname.split('/');
    if (path[2] === 'signout') {
      this.props.signOut();
    }

    return (
      <DocumentTitle title={pageTitle}>
        {path[2] !== 'signout' && (
          <IntlProvider locale={lang} messages={localeIntl[lang]}>
            <Router>
              <Route render={() => <AuthContainer {...this.props} />} />
            </Router>
          </IntlProvider>
        )}
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => ({
  _auth: state.auth,
  _utils: state.utils,
  router: state.router
});

const mapDispatchToProps = (dispatch) => ({
  setAccount: (data) => {
    dispatch(authAct.setAccount(data))
  },
  signOut: () => {
    dispatch(authAct.signOut())
  },
  signIn: (int, lang, data, onOK) => {
    dispatch(authAct.signIn(int, lang, data, onOK))
  },
  signUp: (int, lang, data) => {
    dispatch(authAct.signUp(int, lang, data))
  },
  setLoginStorage: (user, account) => {
    dispatch(authAct.setLoginStorage(user, account))
  },
  setLang: (lang) => {
    dispatch(utilsAct.setLang(lang))
  },
  setInvCookie: (key, value) => {
    dispatch(utilsAct.setInvCookie(key, value))
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
